import { render, staticRenderFns } from "./CreateRole.vue?vue&type=template&id=55072c6c&scoped=true"
import script from "./CreateRole.vue?vue&type=script&lang=js"
export * from "./CreateRole.vue?vue&type=script&lang=js"
import style0 from "./CreateRole.vue?vue&type=style&index=0&id=55072c6c&prod&scoped=true&lang=css"
import style1 from "./CreateRole.vue?vue&type=style&index=1&id=55072c6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55072c6c",
  null
  
)

export default component.exports